import api from "./coAgentFilterApi";
import {
  loadCoAgentFilterPending,
  loadCoAgentFilterFulfilled,
  loadCoAgentFilterRejected,
  saveCoAgentFilterPending,
  saveCoAgentFilterFulfilled,
  saveCoAgentFilterRejected,
} from "./coAgentFilterSlice";

export function loadCoAgentFilter() {
  return async function (dispatch: any) {
    dispatch(loadCoAgentFilterPending());
    try {
      const data = await api.getCoAgentFilter();
      dispatch(loadCoAgentFilterFulfilled(data));
    } catch (error: any) {
      dispatch(
        loadCoAgentFilterRejected(
          error?.message || "Failed to load co-agent filter",
        ),
      );
    }
  };
}

export function saveCoAgentFilter(coAgentIds: number[]) {
  return async function (dispatch: any) {
    dispatch(saveCoAgentFilterPending());
    try {
      await api.saveCoAgentFilter(coAgentIds);
      dispatch(saveCoAgentFilterFulfilled(coAgentIds));
    } catch (error: any) {
      dispatch(
        saveCoAgentFilterRejected(
          error?.message || "Failed to save co-agent filter",
        ),
      );
    }
  };
}
